import React from 'react';


export function loading() {
  return <div>Loading...</div>;
}
